import initialState from './initialState';
import {
  FETCH_DETAIL_NFA_INIT,
  FETCH_DETAIL_NFA_SUCCESS,
  FETCH_DETAIL_NFA_FAILURE,
  FETCH_DETAIL_NFA_BPM_INIT,
  FETCH_DETAIL_NFA_BPM_SUCCESS,
  FETCH_DETAIL_NFA_BPM_FAILURE,
  FETCH_DETAIL_NFA_RANKING_INIT,
  FETCH_DETAIL_NFA_RANKING_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_FAILURE,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_INIT,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_NO_LOADING_FAILURE,
  FETCH_DETAIL_NFA_RANKING_COUNT_INIT,
  FETCH_DETAIL_NFA_RANKING_COUNT_SUCCESS,
  FETCH_DETAIL_NFA_RANKING_COUNT_FAILURE,
  SET_FILTER_DETAIL_NFA,
  RESET_DETAIL_NFA,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_INIT,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_FAILURE,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_INIT,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_FAILURE,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_INIT,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_SUCCESS,
  FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_FAILURE
} from '../../actions/detail_nfa/types';

export default function detailNfa(state = initialState, action) {
  switch (action.type) {
    case FETCH_DETAIL_NFA_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DETAIL_NFA_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_DETAIL_NFA_FAILURE:
      return {
        ...state,
        datos: {},
        error: action.payload,
        loading: false
      };
    case FETCH_DETAIL_NFA_BPM_INIT:
      return {
        ...state,
        loadingBPM: true
      };
    case FETCH_DETAIL_NFA_BPM_SUCCESS:
      return {
        ...state,
        datosBPM: action.payload.data,
        loadingBPM: false,
        statusBPM: action.payload.status
      };
    case FETCH_DETAIL_NFA_BPM_FAILURE:
      return {
        ...state,
        datosBPM: {},
        loadingBPM: false
      };
    case FETCH_DETAIL_NFA_RANKING_INIT:
      return {
        ...state,
        loadingRanking: true
      };
    case FETCH_DETAIL_NFA_RANKING_SUCCESS:
      return {
        ...state,
        datosRanking: action.payload.data,
        loadingRanking: false,
        statusRanking: action.payload.status
      };
    case FETCH_DETAIL_NFA_RANKING_FAILURE:
      return {
        ...state,
        datosRanking: {},
        loadingRanking: false
      };
    case FETCH_DETAIL_NFA_RANKING_NO_LOADING_INIT:
      return {
        ...state,
        loadingTable: true
      };
    case FETCH_DETAIL_NFA_RANKING_NO_LOADING_SUCCESS:
      return {
        ...state,
        datosRanking: action.concat
          ? state.datosRanking.concat(action.payload.data)
          : action.payload.data,
        loadingTable: false,
        statusRanking: action.payload.status
      };
    case FETCH_DETAIL_NFA_RANKING_NO_LOADING_FAILURE:
      return {
        ...state,
        datosRanking: {},
        loadingTable: false
      };
    case FETCH_DETAIL_NFA_RANKING_COUNT_INIT:
      return {
        ...state
      };
    case FETCH_DETAIL_NFA_RANKING_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        statusCount: action.payload.status
      };
    case FETCH_DETAIL_NFA_RANKING_COUNT_FAILURE:
      return {
        ...state,
        count: {}
      };
    case RESET_DETAIL_NFA:
      return {
        ...state,
        datos: {},
        loading: true,
        error: null,
        status: null,
        datosBPM: [],
        loadingBPM: true,
        statusBPM: null,
        datosRanking: [],
        loadingRanking: true,
        statusRanking: null,
        loadingTable: false,
        count: {},
        statusCount: null
      };
    case SET_FILTER_DETAIL_NFA:
      return {
        ...state,
        filters: {
          date: {
            fechaStartFinal: action.payload.date.fechaStartFinal,
            fechaEndFinal: action.payload.date.fechaEndFinal
          },
          tags: action.payload.tags
        }
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_SUCCESS:
      return {
        ...state,
        datosModalEvolution: action.payload.data,
        loadingModalEvolution: false,
        statusModalEvolution: action.payload.status
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_FAILURE:
      return {
        ...state,
        datosModalEvolution: {},
        loadingModalEvolution: false
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_INIT:
      return {
        ...state,
        loadingModalEvolution: true
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_SUCCESS:
      return {
        ...state,
        datosModalTable: action.payload.data,
        loadingModalTable: false,
        statusModalTable: action.payload.status
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_FAILURE:
      return {
        ...state,
        datosModalTable: [],
        loadingModalTable: false
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_INIT:
      return {
        ...state,
        loadingModalTable: true
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_SUCCESS:
      return {
        ...state,
        datosModalEvolutionFilter: action.payload.data,
        loadingModalEvolutionFilter: false,
        statusModalEvolutionFilter: action.payload.status
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_FAILURE:
      return {
        ...state,
        datosModalEvolutionFilter: {},
        loadingModalEvolutionFilter: false
      };
    case FETCH_DETAIL_NFA_MODAL_EVOLUTION_FILTER_INIT:
      return {
        ...state,
        loadingModalEvolutionFilter: true
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_SUCCESS:
      return {
        ...state,
        datosModalTableCount: action.payload.data,
        loadingModalTableCount: false,
        statusModalTableCount: action.payload.status
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_FAILURE:
      return {
        ...state,
        datosModalTableCount: {},
        loadingModalTableCount: false
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_COUNT_INIT:
      return {
        ...state,
        loadingModalTableCount: true
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_INIT:
      return {
        ...state,
        loadingModalTableNoLoading: true
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_SUCCESS:
      return {
        ...state,
        datosModalTable: action.concat
          ? state.datosModalTable.concat(action.payload.data)
          : action.payload.data,
        loadingModalTableNoLoading: false,
        statusModalTable: action.payload.status
      };
    case FETCH_DETAIL_NFA_MODAL_TABLE_NO_LOADING_FAILURE:
      return {
        ...state,
        datosModalTable: [],
        loadingModalTableNoLoading: false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/detail_nfa/index.js